import React, { FunctionComponent } from 'react'
import Svg, { G, Mask, Path } from 'react-native-svg'

type MeetWithAProviderIllustrationProps = {
  width?: number
  height?: number
}

export const MeetWithAProviderIllustration: FunctionComponent<MeetWithAProviderIllustrationProps> = ({
  width = 48,
  height = 48,
}) => (
  <Svg width={width} height={height} viewBox='0 0 48 48' fill='none'>
    <Mask
      id='a'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x={0}
      y={0}
      width={48}
      height={48}
    >
      <Path
        d='M24.167.58c-3.278 0-6.458.561-9.452 1.67C7.586 4.891 2.575 10.75.965 18.32c-1.065 4.937-.929 9.503.418 13.952C3.102 37.956 7.322 42.748 12.96 45.42c2.8 1.33 6.015 2.089 9.556 2.256.455.02.918.032 1.378.032 2.841 0 5.7-.39 8.495-1.157.215-.053.42-.109.636-.173 2.513-.735 4.774-1.899 6.709-3.454 2.1-1.678 3.83-3.806 5.134-6.321.257-.496.503-1.017.774-1.641 1.492-3.465 2.213-7.343 2.085-11.22-.06-1.714-.315-3.537-.756-5.42-.726-3.058-1.91-5.933-3.425-8.32-.415-.641-.795-1.18-1.173-1.664-2.722-3.511-6.963-5.975-12.261-7.122A28.088 28.088 0 0024.168.58h-.001z'
        fill='#FFE9E3'
      />
    </Mask>
    <G mask='url(#a)'>
      <Path
        d='M27.723 9.341s-2-3.538-5.179-2.41c-3.179 1.127-2.922 2.923-4.46 4.102-1.538 1.18-3.026 1.54-3.59 3.282-.563 1.743-.102 3.384-1.539 5.384-1.436 2-3.846 10.102-.922 10.46 2.923.358 19.535 2.153 19.535 2.153s3.846-3.59 3.436-7.179c-.41-3.589-1.334-3.025-1.18-5.28.155-2.256.155-4.103-1.076-5.333-1.231-1.23-.513-4.87-4.512-4.41l-.514-.769h.001z'
        fill='#7F6246'
      />
      <Path
        d='M40.585 42.202c1.674-1.51 2.11-3.973 1.11-5.994-2.685-5.417-6.478-6.835-10.818-8.459l-.412-.154c-3.686-1.382-6.106-1.259-7.903-1.167-.403.02-.774.04-1.122.04-1.897 0-7.23.718-10.666 3.332-.73.555-1.404 1.631-2.013 2.982-2.114 4.686-.446 10.437 4.2 12.639 2.799 1.33 6.015 2.088 9.556 2.255.455.02.918.032 1.377.032 2.842 0 5.7-.39 8.496-1.157.215-.053.42-.109.635-.172 2.513-.736 4.775-1.9 6.71-3.454.29-.233.574-.473.85-.723z'
        fill='#00A4B3'
      />
      <Path
        d='M20.364 22.89s-.4 3.8-.462 4.197c.154.771 1.59 3.183 4.308 3.135 2.717-.05 4.204-2.267 4.306-3.135-.098-.114-.797-4.064-1.053-5.704-.257-1.64-5.664-2.543-7.1 1.509v-.002z'
        fill='#D08B5B'
      />
      <Path
        d='M20.363 22.89s-.06.492-.16 1.5c-.034.346 1.257 2.994 3.974 2.945 2.718-.049 3.927-2.216 3.872-2.528a221.19 221.19 0 01-.587-3.424c-.256-1.64-5.663-2.543-7.1 1.509v-.002z'
        fill='#BF7A4B'
      />
      <Path
        d='M18.826 18.98s-.464 6 5.074 6.153c5.537.154 6.102-4.564 6.256-5.026.154-.462 2-1.076 1.692-2.666-.307-1.59-1.846-1.283-1.846-1.283s.175-4.769-3.374-4.82c-3.548-.05-6.113.565-6.83 3.026-.72 2.462-.972 4.615-.972 4.615z'
        fill='#D08B5B'
      />
      <Path
        d='M20.413 17.436c.453.001.885.345.983.789.124.47-.185.934-.676.957-.569.048-1.245-.437-1.192-1.05.035-.426.463-.705.873-.696h.012zM28.378 18.229a1.04 1.04 0 00-.983.789c-.124.47.185.933.676.957.569.048 1.245-.437 1.192-1.05-.035-.426-.463-.705-.873-.696h-.012z'
        fill='#CC7A52'
      />
      <Path d='M19.645 16.62s-1.334-1.897-2.256-.307c-.923 1.59 1.793 3.23 1.793 3.23l.462-2.923z' fill='#D08B5B' />
      <Path
        d='M23.997 36.257s6.726-1.577 7.366-1.502c.59.07 1.01.233 1.496 1.641.467 1.358 3.662 15.036 3.668 15.07.34 1.874-.518 2.054-1.329 2.378-.803.322-9.768 2.425-12.154 2.98-.625.145-1.309.164-1.837-.016-.418-.144-.863-.261-1.34-1.795-.608-1.948-3.34-14.936-3.34-14.936s-.292-1.6 1.307-2.084c1.6-.483 6.164-1.734 6.164-1.734l-.001-.002z'
        fill='#EDE6DE'
      />
      <Path
        d='M22.207 36.399s-2.39.385-2.355 1.123c.035.738.05 1.87 1.24 1.776 1.189-.095 7.698-1.707 8.094-2.095.397-.388.081-2.162-.55-2.267-.632-.105-2.422.49-2.422.49s-.772-1.5-2.275-1.038c-1.502.462-1.732 2.01-1.732 2.01z'
        fill='#85CCD5'
      />
      <Path
        d='M27.704 16.99c-.151-.391-.644-.507-.927-.194-.333.324-.36.982-.088 1.304.206.277.6.256.824 0 .26-.265.347-.755.198-1.092l-.007-.017zM22.789 16.686c-.252-1.273-1.647-.456-1.32.555.397.987 1.444.357 1.322-.535l-.002-.02z'
        fill='#5D351B'
      />
      <Path
        d='M24.552 17c-.052-.14-.126-.251-.229-.304-.582-.292-.562 1.195-.621 1.495-.07.35-.16.7-.306 1.026-.062.138-.235.514-.113.658.219.257.783-.183.909-.341.328-.415.433-.959.47-1.486.015-.23.013-.719-.11-1.05V17z'
        fill='#C17540'
      />
      <Path d='M27.393 11.375s1.962 4.778 2.61 4.785c.648.006.512-3.493.512-3.493l-3.122-1.293v.001z' fill='#7F6246' />
      <Path
        d='M28.799 15.63a3.165 3.165 0 00-2.46-1.097c-.386.005-.387.605 0 .598a2.59 2.59 0 012.037.921c.253.292.675-.133.423-.423zM23.533 13.968a2.922 2.922 0 00-2.577.263c-.327.203-.028.721.302.517a2.348 2.348 0 012.115-.204c.361.135.518-.444.16-.578v.002z'
        fill='#5F4832'
      />
      <Path
        d='M26.138 20.896c-.884.667-2.045.85-3.073.405-.35-.152-.656.364-.303.516 1.216.527 2.61.403 3.677-.405.304-.229.005-.75-.302-.516z'
        fill='#9E4420'
      />
      <Path
        d='M27.392 11.374l.178-.233-3.54-1.18-2.361.303-2.567 2.927-.372.422.605 2.58c.02-.006 1.215-.323 2.038-1.289.83-.974 1.33-1.913 2.614-2.057 1.284-.145 3.404-1.471 3.404-1.471l.001-.002z'
        fill='#7F6246'
      />
    </G>
  </Svg>
)
